var render, staticRenderFns
import script from "./MGltf.vue?vue&type=script&lang=js&"
export * from "./MGltf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd076780",
  null
  
)

export default component.exports